module.exports = __webpack_public_path__ + "static/media/answer1.df0bc7f7.svg";